import * as types from "../types";

const initialState = {
  isLoggedIn: false,
  details: {},
  token:""
};

export default function user(state = initialState, { type, payload } = {}) {
  switch (type) {
    case types.USER_LOGIN_SUCCESS:
      return {
        ...state,
        isError: false,
        isLoggedIn: true,
        details: payload.userData,
        token:payload.token
      };

    case types.USER_LOGIN_FAILED:
      return {
        ...state,
        isError: true,
        isLoggedIn: false,
        details:{},
        token:""
      };
    case types.USER_LOGOUT_SUCCESS:
      return {
        ...state,
        isError: false,
        details: {},
        isLoggedIn: false,
        token:""
      };
    case types.USER_LOGOUT_FAILED:
      return {
        ...state,
        isError: true,
        details: {},
        isLoggedIn: false,
        token:""
      };

    default:
      return state;
  }
}
